import { isOverReceipt } from './rules.js';
/**
 * Whether the quantities requested against one purchase order line, summed, exceed what is still
 * open on it; the sum is taken to the column's 9dp scale first, so 1.1 + 2.2 against 3.3 passes.
 */
export function isOverReceiptTotal(qtyToFulfill, qtyFulfilled, requestedQuantities) {
    const requested = requestedQuantities.reduce((total, quantity) => total + quantity, 0);
    return isOverReceipt(qtyToFulfill, qtyFulfilled, Number(requested.toFixed(9)));
}
//# sourceMappingURL=is-over-receipt-total.js.map